<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="window windowsize-xs" [attr.windowed]="windowedname" [class.active]="actief" [class.maximized]="maximized"
     [class.fixedsize]="fixedSize" [class.windowsize-sm]="sizeClasses.sm" [class.windowsize-md]="sizeClasses.md"
     [class.windowsize-lg]="sizeClasses.lg" [class.windowsize-xl]="sizeClasses.xl" #draggableWindow="ngDraggable"  #resizableWindow="ngResizable" #asElement [ngDraggable]="(! maximized)" [handle]="header" (mousedown)="naarVoren()"
     [position]="position" (stopped)="fixPosition()" [ngResizable]="(! maximized) && (! fixedSize)"
     [rzContainment]="container" rzHandles="all"
     [rzMinHeight]="300" [rzMinWidth]="400" (rzResizing)="setSizeclasses()">
  <div class="header" #header (dblclick)="toggleMaximize()">
    <div class="title"><span [class]="icon"></span> {{ title }}</div>
    <div class="icons">
      <button type="button" (click)="toggleMaximize()" *ngIf="! fixedSize">
        <i class="fas" [class.fa-window-maximize]="!maximized" [class.fa-window-restore]="maximized"></i>
      </button>
      <button type="button" (click)="close()" *ngIf="closeButton">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <div class="body" #body [id]="bodyId">
    <div class="contentholder">
      <ndc-dynamic [ndcDynamicComponent]="component" [ndcDynamicInputs]="windowedInputs"
                   (ndcDynamicCreated)="contentCreated($event)"></ndc-dynamic>
    </div>
  </div>
  <div class="blokker" *ngIf="blockCount > 0"></div>
</div>
